import React, { Component } from 'react';
import { Icon } from 'react-fa';
import { ListGroup, ListGroupItem, Card, Button, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { fetchData, textChange, sendMessage, textClear, currentTime,
         currentDate, questionSelection, userSelection, broadcastMessageChange,
         messageTitleChange, pushMessage, broadcastMessageClear, clearBroadcastText } from '../../actions/ChatList/ChatListActions';
import { logout } from '../../actions/Auth/UserLoginCheck';
import { connect } from 'react-redux';
import Moment from 'moment';
import ScrollToBottom from 'react-scroll-to-bottom';
import { hashHistory, Link } from 'react-router';
import { css } from 'glamor';
import '../../App.css';
import '../../index.css';
import Header from './../common/Header';

const ROOT_CSS = css({
    height: '82vh', overflowX: 'hidden', overflowY: 'hidden'
});

class AnswerPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: false
        };

        this.toggle = this.toggle.bind(this);
    }

    componentWillMount() {
        const { users } = this.props;
        this.props.fetchData(users);
        const today = new Date();
        const count = (today.toLocaleString()).search(':');
        const time = (today.toLocaleString()).slice(count - 2, count + 6);
        this.props.currentTime(time);
        const date = (today.toLocaleString()).slice(6, 10) + '-' + (today.toLocaleString()).slice(3, 5) + '-' + (today.toLocaleString()).slice(0, 2);
        // date = today.getFullYear() + "-"+ this.formatMonth(monthValue) +"-"+ today.getDate();
        this.props.currentDate(date);
        this.props.clearBroadcastText();
    }

    onBroadcastMessageChange(event) {
        this.props.broadcastMessageChange(event);
    }

    onMessageTitleChange(event) {
        this.props.messageTitleChange(event);
    }

    onTouch(user) {
        this.props.userSelection(user);
    }

    onInputChange(event) {
        this.props.textChange(event);
    }

    toggle() {
        this.setState({
            modal: !this.state.modal
        });
    }

    updateState() {
        const { answer, text } = this.props;
        //const dateAndTime = date + 'T' + time;
        const newObj = {
            answer: text,
            //answered_on: dateAndTime,
            by_admin: true
        };
        const newValue = answer.answers.push(newObj);
        const item = { ...answer, answer: newValue };
        this.props.questionSelection(item);
    }

    formatTime(val) {
        return (
            <span style={{ fontFamily: 'Source Sans Pro', fontSize: 14 }}>
                {Moment(val).format('DD MMM YYYY')}, {Moment(val).format('kk:mm')}
            </span>
        );
    }
    formatAnswerTime(val) {
        return (
            <span style={{ fontFamily: 'Source Sans Pro', fontSize: 14 }}>
                {Moment(val).format('DD MMM YYYY')}, {Moment(val).format('kk:mm')}
            </span>
        );
    }
    
    renderActiveUser(list) {
        if (this.props.user === '') {
            if (list.user.name === this.props.data[0].user.name) {     //shows the 1st user name as active if no user selected
                return (
                    <ListGroupItem style={styles.activeUserStyle}>
                        {list.user.name}
                    </ListGroupItem>
                );
            } else {
                return (
                    <ListGroupItem style={styles.inactiveUserStyle}>
                        {list.user.name}
                    </ListGroupItem>
                );
            }
        } else {
            if (list.user.name === this.props.user.user.name) {       //shows the selected user name as active
                return (
                    <ListGroupItem style={styles.activeUserStyle}>
                        {list.user.name}
                    </ListGroupItem>
                );
            } else {
                return (
                    <ListGroupItem style={styles.inactiveUserStyle}>
                        {list.user.name}
                    </ListGroupItem>
                );
            }
        }
    }

    renderList() {
        return this.props.data.map((list) => {
            return (
                <Link to="/Chat" onClick={this.onTouch.bind(this, list)} key={list.user.name} style={{ textDecoration: 'none' }}>
                    {this.renderActiveUser(list)}
                </Link>
            );
        });
    }

    renderChatList() {
        return (
            <div>
                <ListGroup>
                    {this.renderList()}
                </ListGroup>
            </div>
        );
    }

    renderAnswer() {
        if (this.props.answer == null) {
            return (
                hashHistory.push('/Chat')    // if there is no user selected return to the previous page
            );
        } else {
            return this.props.answer.answers.map((ans, index) => {
                return (
                    <div style={{ padding: 10 }} key={index}>
                        {
                            ans.by_admin === true ?
                                <div className="row">
                                    <div className="col-md-6" />
                                    <div className="col-md-6">
                                        <Card style={styles.adminCardStyle}>
                                            <span className="answerStyle" style={{ color: '#417505' }}>
                                               {ans.answer}
                                            </span>
                                            <span className="answerStyle" style={{ color: '#7ed321' }}>
                                               {this.formatAnswerTime(ans.answered_on)}
                                            </span>
                                        </Card>
                                    </div>
                                </div> :
                                <div className="row">
                                    <div className="col-md-6">
                                        <Card style={styles.userCardStyle}>
                                            <span className="answerStyle" style={{ color: '#4a4a4a' }}>
                                               {ans.answer}
                                            </span>
                                            <span className="answerStyle" style={{ color: '#9b9b9b' }}>
                                               {this.formatAnswerTime(ans.answered_on)}
                                            </span>
                                        </Card>
                                    </div>
                                    <div className="col-md-6" />
                                </div>
                        }
                    </div>
                );
            });
        }
    }

    renderQuestion() {
        if (this.props.answer == null) {
            return (
                hashHistory.push('/Chat')     // if there is no user selected return to the previous page
            );
        } else {
            return (
            <Card style={styles.cardStyle}>
                <span style={{ fontFamily: 'Source Sans Pro-SemiBold', padding: 7, paddingLeft: 10 }}>
                     {this.props.answer.question}
                </span>
                <div className="row" style={{ padding: 5, paddingLeft: 10 }}>
                    <div className="col-md-6 col-xs-6">
                <span style={{ fontFamily: 'Source Sans Pro', color: '#9b9b9b' }}>
                     {this.formatTime(this.props.answer.asked_on)}
                </span>
                    </div>
                    <div className="col-md-6 col-xs-6" style={{ textAlign: 'center' }}>
                        {
                            this.props.user === '' ?
                                <span style={{ fontFamily: 'Source Sans Pro', color: '#9b9b9b' }}>
                                    {this.props.data[0].user.name}
                                </span> :
                                <span style={{ fontFamily: 'Source Sans Pro', color: '#9b9b9b' }}>
                                    {this.props.user.user.name}
                                </span>
                        }
                    </div>
                </div>
            </Card>
            );
        }
    }

    render() {
        const { text, users } = this.props;

        return (
            <div style={{ overflowX: 'hidden', overflowY: 'hidden', height: '100vh' }}>
                <Header />
                <div className="row">
                    <div className="col-xs-6 col-md-4">
                        {/* user list */}
                        <div style={{ padding: 25, overflowX: 'hidden', overflowY: 'scroll', height: '90vh' }}>
                            <div className="row" style={{ paddingBottom: 10 }}>
                                <div className="col" />
                                <div className="col">
                                    <Button
                                        style={styles.broadcastMessageButtonStyle}
                                        onClick={this.toggle}
                                    >
                                          <span style={{ fontSize: 15 }}>
                                              Broadcast Message
                                          </span>
                                    </Button>
                                    <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                                        <ModalHeader toggle={this.toggle}>Message Box</ModalHeader>
                                        <ModalBody>
                                            <input
                                                style={styles.broadcastStyle}
                                                placeholder="Enter Title"
                                                value={this.props.messageTitle}
                                                onChange={event => this.onMessageTitleChange(event.target.value)}
                                            />
                                            <div style={{ paddingTop: 15 }}>
                                                        <textarea
                                                            rows="5"
                                                            placeholder="Enter Your Message"
                                                            style={styles.textAreaStyle}
                                                            value={this.props.broadcastText}
                                                            onChange={event => this.onBroadcastMessageChange(event.target.value)}
                                                        />
                                            </div>
                                        </ModalBody>
                                        <ModalFooter>
                                            {
                                                this.props.messageTitle.length === 0 || this.props.broadcastText.length === 0 ?
                                                    <button type="button" className="btn btn-default" disabled="disabled">
                                                        Push
                                                    </button> :
                                                    <Button
                                                        style={styles.pushMessageButtonStyle}
                                                        onClick={() => {
                                                           this.props.pushMessage(users, this.props.messageTitle, this.props.broadcastText);
                                                           this.props.broadcastMessageClear();
                                                           this.toggle();
                                                        }}
                                                    >
                                                        Push
                                                    </Button>
                                            }
                                        </ModalFooter>
                                    </Modal>
                                </div>
                            </div>
                            {this.renderChatList()}
                        </div>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-8">
                        <ScrollToBottom className={ROOT_CSS}>
                            <div className="row" style={{ paddingLeft: 40, paddingTop: 40 }}>
                                {/* questions */}
                                <div className="col-md-6">
                                    {this.renderQuestion()}
                                </div>
                                <div className="col-md-6" />
                            </div>
                            {/* answers */}
                            <div style={{ paddingLeft: 40, paddingTop: 40 }}>
                                {this.renderAnswer()}
                            </div>
                        </ScrollToBottom>
                        <div>
                            {/* send button for message */}
                            <div style={{ paddingTop: 10 }}>
                                <input
                                    type="text"
                                    placeholder="Enter a Comment"
                                    style={styles.inputStyle}
                                    value={this.props.text}
                                    onChange={event => this.onInputChange(event.target.value)}
                                />
                                {
                                    text.length === 0 ?
                                        <Button style={styles.buttonStyle}>
                                            <Icon
                                                name="paper-plane"
                                                aria-hidden="true"
                                                style={{ fontColor: '#fff' }}
                                            />
                                        </Button>
                                        :
                                        <Button
                                            style={styles.buttonStyle}
                                            onClick={() => {
                                           this.props.sendMessage(users, this.props.answer.question, this.props.answer.id, text);
                                           this.props.textClear(); this.updateState();
                                           }}
                                        >
                                            <Icon
                                                name="paper-plane"
                                                aria-hidden="true"
                                                style={{ fontColor: '#fff' }}
                                            />
                                        </Button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = {
    broadcastStyle: {
        width: '100%',
        height: 40,
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#ced4da',
        borderTopColor: '#ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0,
        borderWidth: '0.5px'
    },
    textAreaStyle: {
        width: '100%',
        paddingLeft: 20,
        borderRadius: '4px',
        borderColor: '#9b9b9b',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    inputStyle: {
        width: '93%',
        height: 40,
        paddingLeft: 20,
        borderRadius: 10,
        backgroundColor: '#fff',
        border: '2px solid #ced4da',
        boxShadow: 'none',
        fontFamily: 'Source Sans Pro-SemiBold',
        outlineWidth: 0
    },
    buttonStyle: {
        backgroundColor: '#40b508',
        borderWidth: 0,
        height: 40,
        width: 40,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        borderRadius: 40,
        marginLeft: 7,
        marginBottom: 7
    },
    cardStyle: {
        width: '85%',
        borderLeftColor: '#7ed321',
        borderLeftWidth: 15,
        boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    userCardStyle: {
        width: '85%',
        borderColor: '#9b9b9b',
        borderWidth: 0.7,
        boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    adminCardStyle: {
        width: '85%',
        backgroundColor: '#eefedb',
        borderColor: '#7ed321',
        borderWidth: 0.7,
        boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.05)`,
        borderRadius: 10
    },
    activeUserStyle: {
        boxShadow: `0px 0px 15px 0px rgba(0,0,0,0.05)`,
        backgroundColor: '#eefedb',
        borderColor: '#7ed321',
        color: '#000',
        margin: 10,
        fontFamily: 'Source Sans Pro-SemiBold',
        padding: 10
    },
    inactiveUserStyle: {
        color: '#000',
        margin: 10,
        fontFamily: 'Source Sans Pro-SemiBold',
        padding: 10
    },
    broadcastMessageButtonStyle: {
        backgroundColor: '#fff',
        borderWidth: 1,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`,
        color: '#40b508',
        borderColor: '#40b508'
    },
    pushMessageButtonStyle: {
        backgroundColor: '#40b508',
        borderWidth: 0,
        boxShadow: `0px 1px 15px 5px rgba(0,0,0,0.05)`
    }

};

function mapStateToProps(state) {
    return {
        data: state.list.data,
        user: state.list.selectedUser,
        answer: state.list.selectedQuestion,
        broadcastText: state.list.broadcastText,
        messageTitle: state.list.messageTitle,
        time: state.list.time,
        date: state.list.date,
        text: state.list.text,
        users: state.login.user
    };
}

export default connect(mapStateToProps, {
        fetchData,
        userSelection,
        textChange,
        sendMessage,
        textClear,
        currentTime,
        currentDate,
        questionSelection,
        logout,
        broadcastMessageChange,
        messageTitleChange,
        pushMessage,
        broadcastMessageClear,
        clearBroadcastText
    })(AnswerPage);



// WEBPACK FOOTER //
// ./src/components/Chat/QuestionPage.js